'use strict';

module.exports = function requirePromise() {
	if (typeof Promise !== 'function') {
		throw new TypeError('`Promise.prototype.finally` requires a global `Promise` be available.');
	}
};



//////////////////
// WEBPACK FOOTER
// ./~/promise.prototype.finally/requirePromise.js
// module id = 141
// module chunks = 35783957827783 172322841747965